export default __webpack_public_path__ + "static/media/large-frame-bg2.a2205e7b.svg";